<div class="dropdown-selection" [class.-expanded]="isExpandedStyle">
  <mat-button-toggle-group
    name="navigation"
    *ngIf="showNavigationButton"
    #group="matButtonToggleGroup"
    [class.-hide-search]="!displaySearch"
    class="navigation-container"
    [value]="selectedToggleOption"
  >
    <mat-button-toggle value="item" class="navigation-button"> {{ buttonToggleText }}</mat-button-toggle>
  </mat-button-toggle-group>

  <div>
    <div class="dropdown-section">
      <h4 class="dropdown-header">
        {{ headerText }}
      </h4>
      <mat-form-field class="dropdown-search-form-field">
        <span matPrefix class="fa fa-map-marker nav-marker"></span>
        <input autocomplete="off" matInput placeholder="Suche" (keyup)="onItemSearchChange($event)" [(ngModel)]="searchText" (focus)="$event.target.select()" />
      </mat-form-field>
      <div class="dropdown-panel">
        <cdk-virtual-scroll-viewport
          class="virtual-scroll-container"
          [itemSize]="30"
          [maxBufferPx]="200"
          [ngStyle]="{ 'overflow-y': virtualScrollHeight < virtualScrollMaxHeight ? 'hidden' : 'auto' }"
          [style.height.px]="virtualScrollHeight"
          [minBufferPx]="100"
        >
          <ng-container *cdkVirtualFor="let item of filteredItems; trackBy: trackByFn; templateCacheSize: 0">
            <div class="dropdown" [ngClass]="{ deactivated: item.isDeactivated }" [class.-selected]="searchText === item" (click)="selectItem(item)">
              <span>{{ item.displayName }}</span>
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
</div>
